import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import FrequencyEditCron from "@/components/frequency/edit/FrequencyEditCron.vue";
import AssignedVisitPointList from "@/components/visit-point/list/AssignedVisitPointList.vue";
import FloatingButtons from "@/views/FloatingButtons.vue";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";

export const FrequencyEditMixin = {
	name: "FrequencyEdit",
	mixins: [generalPurposeMixin],
	components: {
		vSelect,
		flatPickr,
		FrequencyEditCron,
		AssignedVisitPointList,
		FloatingButtons,
	},
	props: {
		dataFrequency: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			frequencyObject: JSON.parse(JSON.stringify(this.dataFrequency)),
			cronExpresion: "",
			activeNavItem: 0,
			maximize: false,
			durationProps: "12:00:00",
			showDateFreqEdit: new Date(),
		};
	},
	mounted() {
		if (this.frequencyObject.hasOwnProperty("duration") && this.frequencyObject["duration"] !== null) {
			const [hours, minutes, seconds] = this.frequencyObject["duration"].split(":");
			this.hours = parseInt(hours);
			this.minutes = parseInt(minutes);
			this.seconds = parseInt(seconds);
		}
	},
	watch: {
		durationFrequency(val) {
			this.durationProps = val;
			this.frequencyObject.duration = val;
		},
	},
	computed: {
		navbarTitle() {
			if (this.activeNavItem === 0) return this.$t("Crud.Update") + " " + this.$t("TimeWindow.Schedule");
			else if (this.activeNavItem === 1)
				return this.$t("VisitPoints.Add") + " " + this.$t("Routing.Title.VisitPoints");
			else return this.$t("VisitPoints.Add") + " " + this.$t("Vehicles.Vehicles");
		},
		validateForm() {
			return !this.errors.any();
		},
		vehicleIds() {
			return this.frequencyObject["vehicle_id"] && this.frequencyObject["vehicle_id"] !== null
				? this.frequencyObject["vehicle_id"]
				: [];
		},
		visitPointIds() {
			return this.frequencyObject["visit_point_id"] && this.frequencyObject["visit_point_id"] !== null
				? this.frequencyObject["visit_point_id"]
				: [];
		},
		cronExpression() {
			return this.$store.state.frequency.cronExpression;
		},
		durationFrequency() {
			return `${this.hours < 10 ? "0" + this.hours : this.hours}:${
				this.minutes < 10 ? "0" + this.minutes : this.minutes
			}:${this.seconds < 10 ? "0" + this.seconds : this.seconds}`;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		maximizeCalendar(val) {
			this.maximize = val;
		},
		getCronExpresion(val) {
			this.cronExpresion = val;
		},
		validateInputNumberMinutes(event) {
			if (this.minutes.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberSeconds(event) {
			if (this.seconds.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		update() {
			let params = {};
			this.frequencyObject["vehicle_id"] =
				this.$store.state.vehicle.assignedVehicles.length > 0
					? this.$store.state.vehicle.assignedVehicles.map(({id}) => id)
					: [];
			this.frequencyObject["visit_point_id"] =
				this.$store.state.moduleVisitPoint.assignedVisitPoints.length > 0
					? this.$store.state.moduleVisitPoint.assignedVisitPoints.map(({id}) => id)
					: [];
			this.frequencyObject["cron"] = this.$store.state.frequency.cronExpression;
			this.frequencyObject["duration"] = `${this.hours < 10 ? "0" + this.hours : this.hours}:${
				this.minutes < 10 ? "0" + this.minutes : this.minutes
			}:${this.seconds < 10 ? "0" + this.seconds : this.seconds}`;
			params = {...this.frequencyObject};
			delete params.id;
			delete params.update_on;
			delete params.added_on;
			this.$store
				.dispatch("frequency/update", {id: this.frequencyObject.id, items: params})
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Frequency.Messages.TitleConfirmUpdate"),
						text: this.$t("Frequency.Messages.TextConfirmUpdate"),
					});
					this.$vs.loading.close();
					this.$router.push({name: "app-frequency-list"});
					return res;
				})
				.catch((err) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
					});
					console.error(err);
				});
		},
		submitForm() {
			this.$vs.loading();
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.update();
				} else {
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorFields.Title"),
						text: this.$t("ErrorFields.Text"),
					});
					this.$vs.loading.close();
				}
			});
		},
		getShowDate(val) {
			this.showDateFreqEdit = val;
		},
		getEvent() {
			this.frequencyObject.duration = this.durationFrequency;
			this.$refs.frequencyEditCron.getEvents(this.cronExpression);
		},
	},
};
